<template>
  <Form @submit="submit"
        :validation-schema="schema" :initial-values="form">
    <section class="application-create__form">
      <div class="container-xxxl">
        <div class="row">
          <div class="col-xxl-6 offset-xxl-3">
            <h3 class="application__form__title">{{ $lang.app.AGREEMENT }}</h3>
            <div class="application__form__block">
              <div class="input__group">
                <label for="state-id-input" class="label">{{ $lang.app.BRANCH }}</label>
                <div class="select__wrapper">
                  <Field name="stateId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="state-id-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="form.stateId"
                        :options="subStates"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
              <div class="alert alert--orange" v-html="$lang.app.FROM_APPLICANT_HINT_TEXT"></div>
              <div class="input__group">
                <label for="agreement-description-input" class="label">{{ $lang.app.FROM_APPLICANT_TEXT }} ___</label>
                <Field name="agreement.description" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="agreement-description-input"
                         v-model="form.agreement.description"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         placeholder="Введите ФИО Директора">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
              <div class="input__group mb0">
                <label for="agreement-additional-terms-input" class="label">{{ $lang.app.ADDITIONAL_TERMS_OF_THE_PARTIES }}</label>
                <Field name="agreement.additionalTerms" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="agreement-additional-terms-input"
                         v-model="form.agreement.additionalTerms"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         placeholder="Введите дополнительные условия">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="application-create__controls">
      <div class="container-fluid">
        <div class="application-create__controls__wrapper">
          <button type="button" @click="$router.go(-1)" class="button button--cancel">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button"
                  :disabled="submitting">
            {{ $lang.app.SAVE }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </Form>
</template>
<script>
import * as yup from "yup";
import { Field, Form} from "vee-validate";
import applicationApi from "../../../../api/applicant/application";
import stateApi from "../../../../api/ref/state";

export default {
  name: "ApplicantApplicationAgreementEdit",
  components: {
    Field,
    Form,
  },
  props: {
    application: Object
  },
  data() {
    return {
      submitting: false,
      subStates: [],
      form: {
        stateId: this.application.state?.id,
        agreement: {
          description: '',
          additionalTerms: ''
        },
      },
      schema: yup.object({
        stateId: yup.mixed().required(),
        agreement: yup.object({
          description: yup.string().required(),
          additionalTerms: yup.string(),
        }),
      }),
    };
  },
  created() {
    this.initSubStates()
  },
  methods: {
    initSubStates() {
      stateApi.getSubStates()
          .then(response => {
            this.subStates = response.map(el => {
              return {id: el.id, label: this.$lang.$translate({ru: el.nameRu, kg: el.nameKg})}
            })
          }).catch(error => {
        console.log(error);
      })
    },
    submit() {
      this.submitting = true
      applicationApi
          .updateAgreement(this.$route.params.applicationId, this.$route.params.agreementId, this.form)
          .then(() => {
            this.$router.go(-1)
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION);
          })
          .catch((error) => {
            // if (error.response.status === 422) {
            //   this.setValidationErrors(actions, error.response.data.errors);
            // } else {
              this.$snotify.error(error.response.data.message);
            // }
          }).finally(() => {
        this.submitting = false
      });
    },
  },
};
</script>

